import React from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";

// Declaração "Tenho API de cotação" (PO1-3650, épico PO1-3359): tipo, link da
// documentação, contato, e-mail e observação. Usado no pedido de entrada
// (página pública) e na aba "API de cotação" do Cadastro do MeuFrete, por isso
// é controlado e não sabe de HTTP: `value` é o objeto do contrato
// ({ temApi, tipo, docUrl, contatoNome, contatoEmail, observacao }) e
// `onChange` recebe o objeto novo. Só a declaração: a integração em si fica
// para depois.

export const API_TIPOS = [
  { value: "REST", label: "REST (JSON)" },
  { value: "SOAP", label: "SOAP (XML)" },
  { value: "EDI", label: "EDI (arquivo)" },
  { value: "PORTAL", label: "Portal web (sem API)" },
];

export const API_VAZIA = { temApi: false, tipo: "", docUrl: "", contatoNome: "", contatoEmail: "", observacao: "" };

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Erros por campo no padrão { campo: mensagem }; objeto vazio quando está ok.
export function validarApiCotacao(api) {
  const e = {};
  if (!api || !api.temApi) return e;
  if (!api.tipo) e.tipo = "Escolha o tipo.";
  if (api.docUrl && !/^https?:\/\//i.test(String(api.docUrl).trim())) e.docUrl = "Informe um link que comece com http:// ou https://.";
  if (api.contatoEmail && !EMAIL_RE.test(String(api.contatoEmail).trim())) e.contatoEmail = "Informe um e-mail válido.";
  return e;
}

// O que vai para a API: null quando não tem API (o backend trata como ausente).
export function apiCotacaoParaPayload(api) {
  if (!api || !api.temApi) return { temApi: false };
  return {
    temApi: true,
    tipo: api.tipo || null,
    docUrl: String(api.docUrl || "").trim() || null,
    contatoNome: String(api.contatoNome || "").trim() || null,
    contatoEmail: String(api.contatoEmail || "").trim() || null,
    observacao: String(api.observacao || "").trim() || null,
  };
}

export default function ApiCotacaoForm({ value, onChange, erros, disabled, labelStyle, textoStyle }) {
  const v = { ...API_VAZIA, ...(value || {}) };
  const e = erros || {};
  const set = (campo, valor) => onChange && onChange({ ...v, [campo]: valor });
  const erroDe = (campo) => (e[campo] ? <div style={{ color: "#ec250d", fontSize: "0.78rem", marginTop: 2 }}>{e[campo]}</div> : null);

  return (
    <div data-testid="api-cotacao-form">
      <FormGroup check style={{ marginBottom: "0.6rem" }}>
        <Label check style={{ ...textoStyle, cursor: "pointer" }}>
          <Input type="checkbox" checked={Boolean(v.temApi)} onChange={(ev) => set("temApi", ev.target.checked)} disabled={disabled} /> Tenho API de cotação
          <span className="form-check-sign" />
        </Label>
      </FormGroup>
      {v.temApi ? (
        <>
          <Row>
            <Col md="4">
              <FormGroup>
                <Label style={labelStyle}>Tipo *</Label>
                <Input type="select" value={v.tipo || ""} onChange={(ev) => set("tipo", ev.target.value)} disabled={disabled} aria-label="Tipo da API">
                  <option value="">Selecione</option>
                  {API_TIPOS.map((t) => (
                    <option key={t.value} value={t.value}>
                      {t.label}
                    </option>
                  ))}
                </Input>
                {erroDe("tipo")}
              </FormGroup>
            </Col>
            <Col md="8">
              <FormGroup>
                <Label style={labelStyle}>Link da documentação</Label>
                <Input type="url" bsSize="sm" maxLength={500} placeholder="https://" value={v.docUrl || ""} onChange={(ev) => set("docUrl", ev.target.value)} disabled={disabled} aria-label="Link da documentação" />
                {erroDe("docUrl")}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label style={labelStyle}>Contato técnico</Label>
                <Input bsSize="sm" maxLength={100} value={v.contatoNome || ""} onChange={(ev) => set("contatoNome", ev.target.value)} disabled={disabled} aria-label="Contato técnico" />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label style={labelStyle}>E-mail do contato</Label>
                <Input type="email" bsSize="sm" maxLength={256} value={v.contatoEmail || ""} onChange={(ev) => set("contatoEmail", ev.target.value)} disabled={disabled} aria-label="E-mail do contato técnico" />
                {erroDe("contatoEmail")}
              </FormGroup>
            </Col>
          </Row>
          <FormGroup style={{ marginBottom: 0 }}>
            <Label style={labelStyle}>Observação</Label>
            <Input type="textarea" rows={2} maxLength={500} value={v.observacao || ""} onChange={(ev) => set("observacao", ev.target.value)} disabled={disabled} aria-label="Observação sobre a API" placeholder="Autenticação, ambiente de testes, limites..." />
          </FormGroup>
        </>
      ) : null}
    </div>
  );
}
